import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import { APP_VERSION, RECAPTCHA_SITE_KEY } from "../Util/constant";
import { useSideBar } from "./context/SideBarContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContextWrapper from "./ContextWrapper";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AccountProgressLayout from "./shared/AccountProgressLayout";
const App = () => {
  console.log("APP VERSION", APP_VERSION);

  const location = useLocation(); // Replace withRouter with useLocation

  const shouldRenderSidebarAndNavbar = () => {
    return !location.pathname.includes("brokertoken");
  };
  const restrictedPaths = ["login", "register", "forgot-password"];
  const currentPath = window.location.pathname.toLowerCase();
  // Determine whether to render the sidebar and navbar
  const renderSidebarAndNavbar = !restrictedPaths.some((path) => currentPath.includes(path)) && shouldRenderSidebarAndNavbar();

  const { isSideBarOpen } = useSideBar();

  return (
    <>
      <GoogleReCaptchaProvider
        reCaptchaKey={RECAPTCHA_SITE_KEY}
        scriptProps={{
          async: true,
          defer: true,
          appendTo: 'head',
          nonce: undefined,
        }}
      >
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover draggable theme="dark" style={{ zIndex: 99999999999 }} />

        {!renderSidebarAndNavbar ? (
          <>
            <AppRoutes />
          </>

        ) : (
          <ContextWrapper>
            <div className="container-scroller">
              {renderSidebarAndNavbar && <Sidebar />}
              <div className="container-fluid page-body-wrapper">
                {renderSidebarAndNavbar && <Navbar />}
                <div className="main-panel">
                  <div className={`content-wrapper ${isSideBarOpen ? "content-wrapper-margin" : "content-wrapper-margin2"}  content-bg`}  >
                    <AccountProgressLayout>
                      <AppRoutes />
                    </AccountProgressLayout>
                  </div>
                </div>
              </div>
            </div>
          </ContextWrapper>
        )}
      </GoogleReCaptchaProvider>

    </>
  );
};

export default (App); // Removed withRouter
